import FocusTrapStackManager from '../../utils/focus-trap-stack-manager'
import HeaderProps from './_header-props'

class HeaderFocusManager {
    focusTrapStack = new FocusTrapStackManager();

    /**
     * @param {HTMLElement} element
     */
    registerTrap(element) {
        const trapId = element.dataset.headerToggle;
        const navElement = HeaderProps.$navContextBox.querySelector(`#${trapId}`)
        this.focusTrapStack.register(trapId, navElement);
        this.focusTrapStack.deactivate(trapId);
    }

    /**
     * @param {string} trapId
     */
    activateTrap(trapId) {
        this.focusTrapStack.activate(trapId);
    }

    /**
     * @param {string} trapId
     */
    isActive(trapId) {
        this.focusTrapStack.isActive(trapId);
    }

    /**
     * Deactivates trap based on trapId
     * @param {string} trapId
     */
    deactivateTrap(trapId) {
        this.focusTrapStack.deactivate(trapId);
    }

    /**
     * Checks if trap exists
     * @param {string} trapId
     * @returns {boolean}
     */
    hasTrap(trapId) {
        return this.focusTrapStack.hasTrap(trapId)
    }
}

export default new HeaderFocusManager();